import styled from 'styled-components';
import { Button, Flex, getThemeSpace } from 'front-commons/ds';

export const FiltersContainer = styled(Flex)`
	gap: 1rem;
	flex-direction: column;

	div[data-testid='search-wrapper'] {
		width: 100%;
	}

	button[data-testid='clear-filter'] {
		padding: 0;

		&[data-variant='text']:hover {
			background: transparent;

			p {
				color: var(--surface-accent-hover-dark);
			}
		}
	}

	button[data-testid='apply-filters-btn'] {
		width: calc(100% - 3rem);
		bottom: 16px;
		left: 50%;
		position: absolute;
		transform: translateX(-50%);
	}
`;

export const ButtonRemoveFilter = styled(Button)`
	display: flex;
	background-color: var(--greys-300);
	border-radius: 16px;
`;

export const ButtonFilterMobile = styled(Button)`
	display: flex;
	justify-content: space-between;
	align-items: center;

	width: 100%;
	height: 56px;
	gap: ${getThemeSpace('8')};

	background-color: var(--neutral-white) !important;
	border: 1px solid var(--greys-100);
`;
